"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Actions = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../ui");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var arrowRotate = function arrowRotate(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 15V13H3.41L15 1.41L13.59 0L2 11.59V5H0V15H10Z",
    fill: "#25253E"
  }));
};
arrowRotate.defaultProps = {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var history = function history(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15 15.5H3V13.5H15V15.5ZM15 11.5H3V9.5H15V11.5ZM15 7.5H3V5.5H15V7.5ZM0 20.5L1.5 19L3 20.5L4.5 19L6 20.5L7.5 19L9 20.5L10.5 19L12 20.5L13.5 19L15 20.5L16.5 19L18 20.5V0.5L16.5 2L15 0.5L13.5 2L12 0.5L10.5 2L9 0.5L7.5 2L6 0.5L4.5 2L3 0.5L1.5 2L0 0.5V20.5Z",
    fill: "#25253E"
  }));
};
history.defaultProps = {
  width: "18",
  height: "21",
  viewBox: "0 0 18 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var RoundButtonWithMargin = (0, _styledComponents.default)(_ui.RoundButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0 10px;\n"])));
var Actions = function Actions(_ref) {
  var className = _ref.className,
    onDepositClick = _ref.onDepositClick,
    onSendClick = _ref.onSendClick,
    onHistoryClick = _ref.onHistoryClick,
    ticker = _ref.ticker;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libCommon', 'libWallets']),
    t = _useTranslation.t;
  var depositRef = _react.default.useRef(null);
  var sendRef = _react.default.useRef(null);
  var historyRef = _react.default.useRef(null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex ".concat(className)
  }, onDepositClick && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: depositRef
  }, /*#__PURE__*/_react.default.createElement(RoundButtonWithMargin, {
    icon: /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: arrowRotate
    }),
    onClick: onDepositClick
  })), /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    placement: "bottom",
    target: depositRef
  }, /*#__PURE__*/_react.default.createElement(_ui.MediumSpan, {
    className: "text-nowrap"
  }, t('deposit')))), /*#__PURE__*/_react.default.createElement("div", {
    ref: sendRef
  }, /*#__PURE__*/_react.default.createElement(RoundButtonWithMargin, {
    icon: /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: arrowRotate,
      rotate: 180
    }),
    onClick: onSendClick
  })), /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    placement: "bottom",
    target: sendRef
  }, /*#__PURE__*/_react.default.createElement(_ui.MediumSpan, {
    className: "text-nowrap"
  }, t('send'))), /*#__PURE__*/_react.default.createElement("div", {
    ref: historyRef
  }, /*#__PURE__*/_react.default.createElement(RoundButtonWithMargin, {
    icon: /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: history
    }),
    onClick: function onClick() {
      return onHistoryClick(ticker);
    }
  })), /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    placement: "bottom",
    target: historyRef
  }, /*#__PURE__*/_react.default.createElement(_ui.MediumSpan, {
    className: "text-nowrap"
  }, t('libWallets:history'))));
};
exports.Actions = Actions;